var _desc, _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYouTubeShorts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "#0f0f0f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.5511 0 0 3.5511 499.9953 499.9953)",
    id: 976413
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.81 0 0 2.81 -0.1604 -0.1431)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-44.994, -45.0001)",
    d: "M 30.063 90 c -6.765 0 -13.323 -3.634 -16.759 -10.009 c -4.669 -8.691 -1.799 -19.627 6.535 -24.901 c 0.049 -0.03 0.099 -0.06 0.15 -0.086 c 0.673 -0.349 1.33 -0.708 1.989 -1.081 c -0.487 -0.279 -0.972 -0.555 -1.464 -0.83 c -5.12 -2.956 -8.263 -7.114 -9.115 -12.038 c -1.115 -6.588 -1.112 -14.914 8.886 -20.927 c 7.687 -4.595 15.564 -9.093 23.183 -13.444 c 2.527 -1.443 5.056 -2.887 7.585 -4.338 c 5.279 -3.008 11.797 -3.129 17.436 -0.329 c 5.692 2.826 9.569 8.152 10.373 14.247 c 1.166 7.769 -2.72 15.545 -9.677 19.315 c -0.449 0.254 -0.885 0.504 -1.313 0.751 c 0.409 0.244 0.816 0.483 1.227 0.715 c 5.715 3.216 9.323 8.684 9.899 14.999 c 0.568 6.244 -1.953 12.194 -6.916 16.325 c -1.584 1.287 -3.325 2.268 -5.008 3.216 c -0.487 0.274 -0.975 0.549 -1.455 0.83 c -7.804 4.547 -17.067 9.922 -26.608 15.32 C 36.162 89.271 33.091 90 30.063 90 z M 21.907 58.516 c -6.513 4.174 -8.746 12.756 -5.08 19.579 c 3.927 7.284 13.009 10.041 20.251 6.138 c 9.485 -5.367 18.734 -10.735 26.526 -15.275 c 0.497 -0.29 1.002 -0.574 1.507 -0.86 c 1.609 -0.906 3.129 -1.762 4.432 -2.821 c 3.918 -3.26 5.918 -7.958 5.472 -12.872 c -0.454 -4.984 -3.326 -9.314 -7.88 -11.877 c -0.734 -0.415 -1.449 -0.845 -2.191 -1.292 c -0.628 -0.378 -1.277 -0.769 -1.975 -1.172 c -0.61 -0.352 -0.99 -0.999 -1.001 -1.704 c -0.01 -0.705 0.352 -1.363 0.951 -1.732 c 1.398 -0.861 2.773 -1.671 4.329 -2.551 c 5.513 -2.987 8.576 -9.111 7.654 -15.256 c -0.635 -4.808 -3.695 -8.99 -8.192 -11.223 c -4.445 -2.207 -9.558 -2.125 -13.671 0.219 c -2.526 1.45 -5.057 2.895 -7.587 4.339 c -7.601 4.341 -15.462 8.83 -23.11 13.401 c -6.346 3.817 -8.376 8.691 -7 16.821 c 0.65 3.762 3.056 6.871 7.149 9.234 c 1.452 0.814 2.868 1.639 4.46 2.583 c 0.606 0.359 0.979 1.011 0.981 1.715 c 0.002 0.705 -0.367 1.359 -0.971 1.721 C 25.216 56.681 23.628 57.622 21.907 58.516 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.81 0 0 2.81 7.6768 0.3726)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-47.783, -45.1836)",
    d: "M 36.741 59.95 c -0.345 0 -0.69 -0.089 -0.999 -0.268 c -0.62 -0.357 -1.002 -1.018 -1.002 -1.733 V 32.417 c 0 -0.715 0.381 -1.375 1 -1.732 c 0.619 -0.357 1.382 -0.357 2 0 l 22.085 12.737 c 0.619 0.357 1 1.016 1.001 1.731 c 0.001 0.715 -0.38 1.374 -0.997 1.733 L 37.744 59.681 C 37.433 59.861 37.087 59.95 36.741 59.95 z M 38.741 35.88 V 54.48 l 16.088 -9.321 L 38.741 35.88 z",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5485 0 0 0.5098 518.0208 499.9963)",
    id: 771492
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-256, -256)",
    d: "M 405.2 232.9 L 126.8 67.2 c -3.4 -2 -6.9 -3.2 -10.9 -3.2 c -10.9 0 -19.8 9 -19.8 20 H 96 v 344 h 0.1 c 0 11 8.9 20 19.8 20 c 4.1 0 7.5 -1.4 11.2 -3.4 l 278.1 -165.5 c 6.6 -5.5 10.8 -13.8 10.8 -23.1 C 416 246.7 411.8 238.5 405.2 232.9 z",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeShorts);
export default __webpack_public_path__ + "static/media/YouTubeShorts.4501444dda381dfda001a8d533ccb90e.svg";
export { ForwardRef as ReactComponent };